import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { ArrowUpRight, Clock } from "lucide-react";
import PageHero from "../components/PageHero";
import Seo from "../components/Seo";
import { Reveal } from "../components/Reveal";
import api from "../lib/api";
import { IMAGES } from "../data/content";

const COVERS = [IMAGES.interior3, IMAGES.carnet, IMAGES.facade];

export default function Conseils() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.articles()
      .then((r) => setArticles(r.articles || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="conseils-page">
      <Seo title="Conseils & actualités — secteur d'Amiens" path="/conseils"
        description="Conseils pratiques pour propriétaires et locataires : entretien du logement, états des lieux et location dans le secteur d'Amiens." />
      <PageHero
        overline="Le blog Speed Détresse"
        title={["Conseils &", "actualités"]}
        subtitle="Entretien, états des lieux, location : nos repères pratiques pour bien gérer un logement dans le secteur d'Amiens."
        testid="conseils-hero"
      />

      <section className="relative z-10 mx-auto max-w-7xl px-5 py-14 lg:px-8">
        {loading ? (
          <p className="py-10 text-center text-slate-500">Chargement…</p>
        ) : articles.length === 0 ? (
          <p className="py-10 text-center text-slate-500">Aucun article publié pour le moment.</p>
        ) : (
          <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
            {articles.map((a, i) => (
              <Reveal key={a.slug} delay={(i % 3) * 0.08}>
                <Link to={`/conseils/${a.slug}`} data-testid={`article-card-${a.slug}`}
                  className="group flex h-full flex-col overflow-hidden rounded-3xl border border-white/10 bg-navy-surface/60 transition-colors hover:border-gold/40">
                  <div className="relative aspect-[16/10] overflow-hidden">
                    <img src={a.cover || COVERS[i % COVERS.length]} alt={a.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                    <div className="absolute inset-0 bg-gradient-to-t from-navy/70 to-transparent" />
                    <span className="absolute left-4 top-4 rounded-full bg-gold px-3 py-1 text-xs font-semibold text-navy">{a.tag}</span>
                  </div>
                  <div className="flex flex-1 flex-col p-6">
                    <h2 className="font-serif text-2xl text-white">{a.title}</h2>
                    <p className="mt-3 flex-1 text-sm text-slate-400">{a.excerpt}</p>
                    <div className="mt-5 flex items-center justify-between text-sm">
                      <span className="flex items-center gap-1.5 text-slate-500"><Clock className="h-3.5 w-3.5" /> {a.read}</span>
                      <span className="flex items-center gap-1.5 text-gold">Lire <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" /></span>
                    </div>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
